import main from "./index";
import { LocalizationContents } from "./Game/LocalizationContents";

LocalizationContents.setLanguage('en')

const m = new main();


